/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './Message';

/**
 * 
 * @export
 * @interface GetThreadMessagesResponse
 */
export interface GetThreadMessagesResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof GetThreadMessagesResponse
     */
    messages: Array<Message>;
}

/**
 * Check if a given object implements the GetThreadMessagesResponse interface.
 */
export function instanceOfGetThreadMessagesResponse(value: object): value is GetThreadMessagesResponse {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function GetThreadMessagesResponseFromJSON(json: any): GetThreadMessagesResponse {
    return GetThreadMessagesResponseFromJSONTyped(json, false);
}

export function GetThreadMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetThreadMessagesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
    };
}

export function GetThreadMessagesResponseToJSON(json: any): GetThreadMessagesResponse {
    return GetThreadMessagesResponseToJSONTyped(json, false);
}

export function GetThreadMessagesResponseToJSONTyped(value?: GetThreadMessagesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(MessageToJSON)),
    };
}

